import React from 'react';

import {
    ListItem,
    ListItemButton,
    ListItemIcon,
    type ListItemProps,
    ListItemText
} from '@mui/material';
import styled from 'styled-components';

const StyledListItem: typeof ListItem = styled(ListItem)`
    display: contents;
`;

const StyledListItemIcon: typeof ListItemIcon = styled(ListItemIcon)`
    min-width: 0;
    margin-right: 0.5rem;
`;

const StyledListItemButton: typeof ListItemButton = styled(ListItemButton)`
    height: 2.5rem;
`;

export type EditableListButtonProps =
    ListItemProps &
    {
        onClick: (event: any) => void;
        icon?: any;
        title: string;
    };

export const EditableListButton = (props: EditableListButtonProps) => {
    const { onClick, icon, title, ...itemProps } = props;

    return (
        <StyledListItem {...itemProps}>
            <StyledListItemButton onClick={onClick}>
                {icon && (
                    <StyledListItemIcon>
                        {icon}
                    </StyledListItemIcon>
                )}

                <ListItemText primary={title} />
            </StyledListItemButton>
        </StyledListItem>
    );
};
